import { create } from "zustand";
const KEY = "crashx:muted";
function savedMute(): boolean {
  try {
    return localStorage.getItem(KEY) !== "false";
  } catch {
    return true;
  }
}
export const useAudioStore = create<{ muted: boolean; setMuted: (muted: boolean) => void }>((set) => ({
  muted: savedMute(),
  setMuted: (muted) => {
    try {
      localStorage.setItem(KEY, String(muted));
    } catch {
      /* Storage may be disabled. */
    }
    set({ muted });
  },
}));
